// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__8ugOO","navItem":"Header_navItem__1eD-1"};